import React from 'react';

const Header = () => {
    return (
        <header className="header" data-header>

            <div className="overlay" data-overlay></div>

            <div className="header-top">
                <div className="container">

                    <a href="tel:+01123456790" className="helpline-box">

                        <div className="icon-box">
                            <ion-icon name="call-outline"></ion-icon>
                        </div>

                        <div className="wrapper">
                            <p className="helpline-title">For Further Inquires :</p>

                            <p className="helpline-number">+233 501 502 441</p>
                        </div>

                    </a>

                    <a href="https://atlanticcatering-gh.com/" className="logo">
                        <img src="./assests/images/atlantic-logo.png" style={{ width: "100px" }} alt="atlantic logo" />
                    </a>

                    <div className="header-btn-group">

                        <a href="https://atlanticcatering-gh.com/" className="btn btn-primary">home</a>

                    </div>

                </div>
            </div>

        </header>
    );
};

export default Header;
